import {
	CONTEXT_SET_COUNTRY, CONTEXT_SET_CONTEXT, CONTEXT_SET_CUSTOMER, CONTEXT_SET_CUSTOMERTYPE, SETTING_SET_PERIMETER_FILTER,
	SETTING_SET_VEH_DESC_TYPE, VEHICLE_SET_VEHICLE,
	AVAILABLE_OPTIONS_SET_OPTIONS, AVAILABLE_ACCESSORIES_SET_ACCESSORIES,
	PARAMETERS_SET_PARAMETERS, PARAMETERS_SET_WIDPARAMETERS, SET_PART_EXCHANGE,
	VEHICLES_SET_VEHICLES_CONFIG, VEHICLES_SET_VEHICLES_STOCK
} from '../actions/actionsAppTest';

import HelperContext from '../helpers/HelperContext'
import HelperEnv from '../helpers/HelperEnv'


function buildDefaultContext() {
	let defaultContext = JSON.parse(HelperEnv.getDefaultContext());
	if (defaultContext) {
		return defaultContext;
	}
	return {};
}

export const initialStateContext = buildDefaultContext();

function context(state, action) {
	let distributionBrand;
	let siteCode;
	let journeyType;
	let languageCode;
	switch (action.type) {
		case CONTEXT_SET_COUNTRY:
			distributionBrand = HelperContext.getAppliedDistributionBrand(state.distributionBrand, action.payload.perimeterFilter, action.payload.context.countryCode);
			siteCode = HelperContext.getAppliedSiteCode(state.siteCode, action.payload.perimeterFilter, action.payload.vehDescType, action.payload.context.countryCode, distributionBrand)
			return {
				...state,
				...action.payload.context,
				countryCode: action.payload.context.countryCode,
				distributionBrand: distributionBrand,
				siteCode: siteCode,
				languageCode: HelperContext.getDefaultLangage(action.payload.context.countryCode)
			};
		case CONTEXT_SET_CUSTOMER:
			return { ...state, customer: action.payload.customer };
		case CONTEXT_SET_CUSTOMERTYPE:
			return { ...state, customer: action.payload.context.customer };
		case SETTING_SET_VEH_DESC_TYPE:
			siteCode = HelperContext.getAppliedSiteCode(state.siteCode,
				action.payload.perimeterFilter, action.payload.vehDescType,
				state.countryCode, state.distributionBrand)
			journeyType = HelperContext.adjustJourneyType(action.payload.perimeterFilter, state.customer.clientType,
				siteCode, state.journeyType);
			return { ...state, siteCode: siteCode, journeyType: journeyType }
		case CONTEXT_SET_CONTEXT:
			distributionBrand = HelperContext.getAppliedDistributionBrand(action.payload.context.distributionBrand,
				action.payload.perimeterFilter, action.payload.context.countryCode);
			siteCode = HelperContext.getAppliedSiteCode(action.payload.context.siteCode,
				action.payload.perimeterFilter, action.payload.vehDescType,
				action.payload.context.countryCode, distributionBrand)
			journeyType = HelperContext.adjustJourneyType(action.payload.perimeterFilter, action.payload.context.customer.clientType,
				siteCode, action.payload.context.journeyType);
			return { ...action.payload.context, distributionBrand: distributionBrand, siteCode: siteCode, journeyType: journeyType };
		case SETTING_SET_PERIMETER_FILTER:
			const countryCode = HelperContext.getAppliedCountry(state.countryCode, action.payload.perimeterFilter);
			distributionBrand = HelperContext.getAppliedDistributionBrand(state.distributionBrand, action.payload.perimeterFilter, countryCode);
			siteCode = HelperContext.getAppliedSiteCode(state.siteCode, action.payload.perimeterFilter, action.payload.vehDescType, countryCode, distributionBrand);
			languageCode = HelperContext.getDefaultLangage(countryCode);
			return {
				...state,
				countryCode: countryCode,
				languageCode: languageCode,
				siteCode: siteCode,
				distributionBrand: distributionBrand
			};
		default:
			return { ...state };
	}
}

function vehicle(state, action) {
	if (action.type === VEHICLE_SET_VEHICLE) {
		var pres;
		var veh;
		if (action.payload.vehicle && action.payload.vehicle.presentation == null) {
			var longLabel = "vehicle"
			pres = { longLabel: longLabel }
			veh = { ...action.payload.vehicle, presentation: pres }
			return veh;
		}
		return { ...action.payload.vehicle };
	}
	return state;
}

function availableOptions(state, action) {
	if (action.type === AVAILABLE_OPTIONS_SET_OPTIONS) {
		return Object.values({ ...action.payload.options });
	}
	return state;
}

function availableAccessories(state, action) {
	if (action.type === AVAILABLE_ACCESSORIES_SET_ACCESSORIES) {
		return Object.values({ ...action.payload.accessories });
	}
	return state;
}

function vehiclesConfig(state, action) {
	if (action.type === VEHICLES_SET_VEHICLES_CONFIG) {
		var vehicles = Object.values({ ...action.payload.vehicles });
		for (var i in vehicles) {
			vehicles[i] = { ...vehicles[i], options: undefined, accessories: undefined }
		}
		return vehicles;
	}
	if (state == null) {
		return [];
	}
	return state;
}
function vehiclesStock(state, action) {
	if (action.type === VEHICLES_SET_VEHICLES_STOCK) {
		return Object.values({ ...action.payload.vehicles });
	}
	if (state == null) {
		return [];
	}
	return state
}
function parameters(state, action) {
	switch (action.type) {
		case CONTEXT_SET_COUNTRY:
		case CONTEXT_SET_CONTEXT:
			return {};
		case PARAMETERS_SET_PARAMETERS:
			if (action.payload.parameters == null) {
				return {};
			} else if (action.payload.parameters && action.payload.parameters.payloadBase64 && action.payload.parameters.payloadBase64.trim().length > 0) {
				return JSON.parse(window.atob(action.payload.parameters.payloadBase64));
			} else {
				return { ...action.payload.parameters };
			}
		default:
			return state
	}
}
function parametersForFetch(state, action) {
	switch (action.type) {
		case CONTEXT_SET_COUNTRY:
		case CONTEXT_SET_CONTEXT:
			return {};
		case PARAMETERS_SET_PARAMETERS:
			return action.payload.parameters == null ? {} : { ...action.payload.parameters };
		default:
			return state
	}
}
function partExchange(state, action) {
	if (action.type === SET_PART_EXCHANGE) {
		return action.payload.partExchange == null ? {} : { ...action.payload.partExchange };
	}
	return { ...state }
}
function widgetParameters(state, action) {
	switch (action.type) {
		case CONTEXT_SET_COUNTRY:
		case CONTEXT_SET_CONTEXT:
			return {};
		case PARAMETERS_SET_WIDPARAMETERS:
			return action.payload.widgetParameters == null ? {} : { ...action.payload.widgetParameters }
		default:
			return state
	}
}

export function testCriteria(state, action) {
	return {
		...state,
		context: context(state.context, action),
		vehicle: vehicle(state.vehicle, action),
		availableOptions: availableOptions(state.availableOptions, action),
		availableAccessories: availableAccessories(state.availableAccessories, action),
		vehiclesConfig: vehiclesConfig(state.vehiclesConfig, action),
		vehiclesStock: vehiclesStock(state.vehiclesStock, action),
		parameters: parameters(state.parameters, action),
		parametersForFetch: parametersForFetch(state.parametersForFetch, action),
		partExchange: partExchange(state.partExchange, action),
		widgetParameters: widgetParameters(state.widgetParameters, action),
	};
}
